// extracted by mini-css-extract-plugin
module.exports = {"futureMarriedInput":"FutureMarriedInput__futureMarriedInput__4CUj+","item":"FutureMarriedInput__item__o9gL5"};